// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Heading_wrapper__1NmaX","startbtn":"Heading_startbtn__1ppqx","glow":"Heading_glow__3feQh"};